import { CHAPTERS } from "../../data";
import { Reveal, MaskLineInView } from "./Reveal";

export const Manifesto = () => (
  <section id="about" data-testid="manifesto-section" className="bg-white py-16 md:py-36">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="max-w-3xl">
        <Reveal>
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--brand)]">
            Who we are
          </span>
        </Reveal>
        <h2 className="font-display font-semibold tracking-tighter leading-[1.02] sm:leading-[0.98] mt-5 text-3xl sm:text-5xl md:text-6xl">
          <MaskLineInView>Precision packaging,</MaskLineInView>
          <MaskLineInView delay={0.08}>built for trust.</MaskLineInView>
        </h2>
      </div>

      <div className="mt-16 md:mt-24 border-t border-slate-200">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.no} delay={i * 0.05}>
            <div
              data-testid={`chapter-${c.no}`}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 py-10 md:py-14 border-b border-slate-200 group"
            >
              <div className="md:col-span-2">
                <span className="font-display text-5xl md:text-7xl font-semibold text-slate-200 group-hover:text-[var(--brand)] transition-colors duration-500">
                  {c.no}
                </span>
              </div>
              <h3 className="md:col-span-5 font-display text-2xl md:text-3xl font-medium tracking-tight leading-tight">
                {c.title}
              </h3>
              <p className="md:col-span-5 text-base md:text-lg leading-relaxed text-[var(--muted)] md:pt-1">
                {c.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
